import { render, staticRenderFns } from "./TagInfoBox.vue?vue&type=template&id=28cf5942&scoped=true"
import script from "./TagInfoBox.vue?vue&type=script&lang=js"
export * from "./TagInfoBox.vue?vue&type=script&lang=js"
import style0 from "./TagInfoBox.vue?vue&type=style&index=0&id=28cf5942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf5942",
  null
  
)

export default component.exports